<div class="recipe-detail-page" *ngIf="!isLoading && recipe; else loadOrError">

  <!-- Breadcrumb + Share Row -->
  <div class="container topbar">
    <nav class="breadcrumb">
      <a routerLink="/recipes">Recipes</a>
      <span class="sep">/</span>
      <span *ngFor="let tag of recipe.tags; let last = last">
        {{ tag }}<span *ngIf="!last" class="sep"> / </span>
      </span>
    </nav>
    <div class="share-bar">
      <span class="share-label">Share this recipe</span>
      <a href="#" class="share-icon" aria-label="Share on Facebook" title="Facebook">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
      </a>
      <a href="#" class="share-icon" aria-label="Share on Pinterest" title="Pinterest">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>
      </a>
      <a href="#" class="share-icon" aria-label="Copy link" title="Copy link">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
      </a>
    </div>
  </div>

  <!-- Hero Split -->
  <div class="container hero-split">
    <div class="hero-left">
      <div class="hero-tags">
        <span *ngFor="let tag of recipe.tags" class="tag-badge">{{ tag }}</span>
      </div>
      <h1 class="recipe-title">{{ recipe.title }}</h1>
      <div class="meta-row">
        <span class="meta-item">⏱ Prep {{ recipe.prepTime }}</span>
        <span class="sep">|</span>
        <span class="meta-item">Chill time {{ recipe.cookTime }}</span>
        <span class="sep">|</span>
        <span class="meta-item">Serves {{ recipe.servings }}</span>
      </div>

    </div>
    <div class="hero-right">
      <div class="hero-image-wrap">
        <img [src]="getImgSrc(recipe.imageUrl)" [alt]="recipe.title" class="hero-img">
        <div class="image-overlay-tags">
          <span *ngFor="let tag of recipe.tags" class="overlay-tag">{{ tag }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Body Content -->
  <div class="container body-layout">

    <!-- Left Column: Intro + Method -->
    <main class="body-main">
      <section class="intro-section">
        <h2 class="section-heading">Introduction</h2>
        <p class="intro-text">{{ recipe.description }}</p>
      </section>

      <section class="method-section">
        <h2 class="section-heading">Method</h2>
        <ol class="method-list">
          <li *ngFor="let step of recipe.instructions; let i = index" class="method-step">
            <span class="step-num">{{ i + 1 }}</span>
            <p class="step-text">{{ step }}</p>
          </li>
        </ol>
      </section>
    </main>

    <!-- Right Column: Ingredients (sticky) -->
    <aside class="body-aside">
      <div class="ingredients-card">
        <h3 class="card-heading">Ingredients</h3>
        <ul class="ingredients-list">
          <li *ngFor="let ing of recipe.ingredients" class="ingredient-item">
            <label class="ingredient-label">
              <input type="checkbox" class="ing-check">
              <span class="ing-text">{{ ing }}</span>
            </label>
          </li>
        </ul>
      </div>
    </aside>

  </div>

</div>

<!-- Loading / Error -->
<ng-template #loadOrError>
  <div class="load-error section-padding text-center">
    <div *ngIf="isLoading" class="spinner"></div>
    <div *ngIf="error">
      <h2>Recipe not found</h2>
      <a routerLink="/recipes" class="btn btn-primary">Back to Recipes</a>
    </div>
  </div>
</ng-template>
